import {
    useEventNotification,
    useEventNotificationsStore,
} from '../event-notifications/use-event-notifications';
import React from 'react';
import {
    eventPanelEventNotificationToNotificationGroup,
    eventPanelNotificationGroupToNotifications,
} from '../event-notifications/event-panel-event-notification-groups';
import { CadNextNotificationTypeEnumType } from '@mark43/cad-api';

export function useFormEventNotificationControl(
    eventNotificationName?: CadNextNotificationTypeEnumType
) {
    const eventNotificationsStore = useEventNotificationsStore();
    const eventNotification = useEventNotification({ notification: eventNotificationName });
    const removeEventNotification = React.useCallback(() => {
        if (eventNotification) {
            const notificationGroup =
                eventPanelEventNotificationToNotificationGroup[eventNotification.notificationType];
            if (notificationGroup) {
                const eventNotificationsToDismiss =
                    eventPanelNotificationGroupToNotifications[notificationGroup];
                eventNotificationsStore.removeNotifications({
                    eventId: eventNotification.eventId,
                    notifications: eventNotificationsToDismiss,
                    entityId: eventNotification.entityId,
                });
            } else {
                eventNotificationsStore.removeNotification({
                    eventId: eventNotification.eventId,
                    notification: eventNotification.notificationType,
                    entityId: eventNotification.entityId,
                });
            }
        }
    }, [eventNotification, eventNotificationsStore]);

    return { removeEventNotification, eventNotification };
}
